package co.maytes.standupbot.dashboard.features.settings

import co.maytes.standupbot.shared.dto.appcredentials.KeyCheckRules
import co.maytes.standupbot.shared.dto.appcredentials.TestConnectionResultDto

enum class KeyNoteTone { Success, Danger }

data class KeyNote(val text: String, val tone: KeyNoteTone)

object AnthropicKeyCopy {
    const val NO_KEY = "No key saved yet."
    const val KEY_HELP = "Stored encrypted. The key is never shown again after saving."
    const val UNVERIFIED = "The key could not be verified."

    fun note(check: TestConnectionResultDto?): KeyNote? = when {
        check == null -> null
        check.ok -> KeyNote("Key works. Save it to start using it.", KeyNoteTone.Success)
        else -> KeyNote(check.detail ?: UNVERIFIED, KeyNoteTone.Danger)
    }

    fun saveHint(checking: Boolean, check: TestConnectionResultDto?): String = when {
        checking -> "Checking the key…"
        check == null -> "Check the key before saving."
        check.ok -> "Key checked. Ready to save."
        KeyCheckRules.offersSaveAnyway(check) -> "The check could not finish. You can still save the key."
        else -> "Fix the key, then check it again."
    }
}

enum class ClaudeModel(val id: String, val label: String, val blurb: String) {
    Sonnet55("claude-sonnet-5-5", "Sonnet 5.5", "Best quality for standups. Recommended."),
    Haiku55("claude-haiku-5-5", "Haiku 5.5", "Fastest and about 20 times cheaper per token."),
    ;

    companion object {
        val DEFAULT = Sonnet55

        fun fromId(id: String?): ClaudeModel = entries.firstOrNull { it.id == id } ?: DEFAULT
    }
}
